import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "tab__title" }
const _hoisted_2 = {
  key: 0,
  class: "tab__children"
}
const _hoisted_3 = ["value", "selected"]

import DetailsTabTitle from "@/components/DetailsTabTitle.vue";
import NestingCaret from "@/components/NestingCaret.vue";
import { useRoute, useRouter } from "vue-router";
import { type TabDefinition } from "@/helpers/typesDefinition";


export default /*@__PURE__*/_defineComponent({
  __name: 'Tabs',
  props: {
    definitions: {},
    isVertical: { type: Boolean },
    nesting: {},
    size: {},
    color: {}
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "v3a957720": (_ctx.nesting)
}))

const props = __props;

const router = useRouter();
const route = useRoute();

function isCurrentRoute(tabDef: TabDefinition) {
  if (tabDef.route.name === route.name) return true;
  if (!tabDef.aliases) return false;
  for (const alias of tabDef.aliases) {
    if (alias === route.name) return true;
  }
  return false;
}
function onRouteSelect(event: Event) {
  const elem = event.target as HTMLSelectElement;
  const idx = Number(elem.value);
  const tabDef = props.definitions[idx];
  router.push(tabDef.route);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", _mergeProps({
      class: [
      'tab-buttons',
      __props.color ? `tab-buttons--${__props.color}` : '',
      {
        'tab-buttons--vertical': __props.isVertical,
      },
    ]
    }, _ctx.$attrs), [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.definitions, (tabDef) => {
        return (_openBlock(), _createElementBlock("div", {
          key: tabDef.title,
          class: "tab"
        }, [
          _createElementVNode("div", _hoisted_1, [
            (__props.isVertical && __props.nesting)
              ? (_openBlock(), _createBlock(NestingCaret, {
                  key: 0,
                  level: __props.nesting
                }, null, 8, ["level"]))
              : _createCommentVNode("", true),
            _createVNode(DetailsTabTitle, {
              title: tabDef.title,
              active: isCurrentRoute(tabDef),
              "is-vertical": __props.isVertical,
              size: __props.size,
              color: __props.color,
              "icon-name": tabDef.iconName,
              onClick: ($event: any) => (_ctx.$router.push(tabDef.route))
            }, null, 8, ["title", "active", "is-vertical", "size", "color", "icon-name", "onClick"])
          ]),
          (
          __props.isVertical &&
          __props.nesting &&
          tabDef.children?.length &&
          isCurrentRoute(tabDef)
        )
            ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabDef.children, (child) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: child.title,
                    class: "tab__title"
                  }, [
                    (__props.isVertical && __props.nesting)
                      ? (_openBlock(), _createBlock(NestingCaret, {
                          key: 0,
                          level: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(DetailsTabTitle, {
                      title: child.title,
                      active: isCurrentRoute(child),
                      "is-vertical": __props.isVertical,
                      size: "sm",
                      color: __props.color,
                      "icon-name": child.iconName,
                      onClick: ($event: any) => (_ctx.$router.push(child.route))
                    }, null, 8, ["title", "active", "is-vertical", "color", "icon-name", "onClick"])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ], 16),
    _createElementVNode("div", _mergeProps({ class: "select" }, _ctx.$attrs), [
      _createElementVNode("select", {
        onChange: _cache[0] || (_cache[0] = ($event: any) => (onRouteSelect($event))),
        class: "form-control"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.definitions, (tabDef, idx) => {
          return (_openBlock(), _createElementBlock("option", {
            key: idx,
            value: idx,
            selected: isCurrentRoute(tabDef)
          }, _toDisplayString(tabDef.title), 9, _hoisted_3))
        }), 128))
      ], 32)
    ], 16)
  ], 64))
}
}

})